import { Component, OnInit, Input, ChangeDetectorRef, HostListener } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormBuilder, FormArray, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

// Service
import { LimitFlowProposalService } from '../../service/limit-flow-proposal/limit-flow-proposal.service';
import { CommonService } from '../../../common/service/common.service';
import { Observable, Subscription } from "rxjs/Rx";
import { DialogService } from "ng2-bootstrap-modal";
import { SendToCtcComponent } from "../actions/send-to-ctc/send-to-ctc.component";
import { RequestPendingComponent } from "../actions/request-pending/request-pending.component";
import { RequestPendingApprovalComponent } from "../actions/request-pending-approval/request-pending-approval.component";
import { RequestPendingWarrantyComponent } from "../actions/request-pending-warranty/request-pending-warranty.component";
import { FixedLimitComponent } from "../fixed-limit/fixed-limit.component";
import { ConfirmComponent } from '../../../shared/confirm/confirm.component';
import { CcSerasaModalLCComponent } from './cc-serasa-modal-lc/cc-serasa-modal-lc.component';
import { normalizeDoc } from '../../../cnpj.utils';

@Component({
	selector: 'app-limit-flow-proposal',
	templateUrl: './limit-flow-proposal.component.html',
	styleUrls: ['./limit-flow-proposal.component.scss'],
	providers: [
		CommonService,
		HttpModule
	],
	moduleId: module.id
})
export class LimitFlowProposalComponent implements OnInit {

	@Input('accountClientID') accountClientID: string = "";
	@Input('profileUser') profileUser: string = "";
	@Input('tempGroup') tempGroup: any[] = [];
	@Input('openProposal') openProposal: string = "";
	@Input('proposalIDclosed') proposalIDclosed: string = "";
	@Input('currentClientDocument') currentClientDocument: string = "";
	@Input('accountClientFinancialDetailsLimits') accountClientFinancialDetailsLimits: any[] = [];
	@Input('segmentoID') segmentoID: string = "";
	@Input('proposalOpen') proposalOpen: boolean = false;

	@Input() disabled: boolean;

	guid: string;
	isEdicao: boolean = false;
	timer: any;
	timerSubscription: Subscription;
	autoSaveTime: number;

	private permissoes = [];

	private sub: any;
	private token;
	public experiences: any[] = [];
	public areas: any[] = [];
	public averages: any[] = [];
	public products: any[] = [];

	public clientTypes: any[] = [];
	public accountClients: any[] = [];
	public selectedMarkets: any[] = [];
	public markets: any[] = [];
	public proposalID: string;

	public attachs: any[] = [];

	public proposalProducts: any[] = [];
	public fieldClientTypes: string;
	public clienteComCPF: boolean = false;

	public proposalLayout: number = 0;
	public docList: any[] = [];

	accountClient: FormGroup;
	proposal: FormGroup;

	// Culturas
	cultureForm: FormGroup;
	public productivitys: any[] = [];
	public cultures: any[] = [];
	public states: any[] = [];
	public citys: any[] = [];

	// Tabs
	private proposalLcTab: boolean = true;
	private patrimonyTab: boolean = true;
	private revenueTab: boolean = true;
	private guaranteeTab: boolean = false;
	private ratingTab: boolean = false;
	private summaryTab: boolean = false;
	private attachTab: boolean = true;
	private demosTab: boolean = false;
	private groupTab: boolean = false;
	private blogTab: boolean = false;
	private logTab: boolean = false;

	public reloadGrupTab: boolean = false;

	public TipoProdutoID;
	public Quantidade;
	public TipoMercadoAtuacao;

	public proposalStatus: string = null;
	public automaticSave: boolean = false;
	public lastAutomaticSave: string = "";

	public guaranteesObj: any[] = [];
	public cultureObj: any[] = [];
	public livestockObj: any[] = [];
	public otherRevenueObj: any[] = [];
	public typeOfObj: any[] = [];
	public dreObj: {};
	public referenceObj: any[] = [];
	public ruralsObj: any[] = [];
	public priceByRegionObj: any[] = [];
	public urbansObj: any[] = [];
	public machinesObj: any[] = [];
	public keepProposal: string = "";
	public isUserOwner: boolean = false;
	public SerasaID: string = "";
	public requiredFields: any[] = [];

	public isSaving = false;
	public isLoadingPatrimony = false;

	public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	public cnpjMask = [/[A-Z0-9]/i, /[A-Z0-9]/i, '.', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '.', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '/', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '-', /\d/, /\d/];

	constructor(
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private commonService: CommonService,
		private flashMessagesService: FlashMessagesService,
		private limitFlowProposalService: LimitFlowProposalService,
		private route: ActivatedRoute,
		private dialogService: DialogService) {

		this.token = localStorage.getItem('yara.token');

		this.accountClient = fb.group({
			Documento: '',
			InscricaoEstadual: '',
			Nome: ''
		});

		this.proposal = fb.group({
			ID: '',
			AprovadoComite: '',
			ContaClienteID: '',
			TipoClienteID: '',
			ExperienciaID: '',
			Documento: '',
			EstadoCivil: '', // Solteiro(a), Casado(a), Divorciado(a), Viúvo(a), Separado(a)
			CPFConjugue: '',
			NomeConjugue: '',
			RegimeCasamento: '', //Comunhão parcial de bens, Comunhão universal de bens, Separação total de bens
			PossuiGerenteTecnico: '', // boolean
			PossuiMaquinarioProprio: '', // boolean
			PossuiArmazem: '', // boolean
			ToneladasArmazem: '', // t
			PossuiAreaIrrigada: '', // boolean
			AreaIrrigadaID: '',
			PossuiContratoProximaSafra: '', // boolean
			Trading: '',
			QtdeSacas: '',
			GrupoEconomicoID: '',
			PrecoSaca: '',
			ClienteGarantia: '', // boolean
			PossuiCriacaoDeAnimais: '', // boolean
			PossuiOutrasReceitas: '', // boolean
			PrincipaisFornecedores: '',
			PrincipaisClientes: '',
			ComentarioMercado: '',
			NecessidadeAnualFertilizantes: '', // t
			PrecoMedioFt: '',
			NecessidadeAnualFoliar: '', // litros
			PrecoMedioLt: '',
			NumeroComprasAno: '',
			ResultadoUltimaSafra: '',
			NumeroClienteCooperados: '',
			PrazoMedioVendas: '',
			IdadeMediaCanavialID: '',
			TotalProducaoAlcool: '', // litros
			TotalProducaoAcucar: '', // t
			VolumeMoagemPropria: '', // t
			CustoMedioProducao: '',
			CapacidadeMoagem: '', // t
			TotalMWAno: '',
			CustoCarregamentoTransporte: '',
			RestricaoSERASA: '', // Sim - Relevante, Sim - Não Relevante, Não
			RestricaoTJ: '', // Sim - Relevante, Sim - Não Relevante, Não
			RestricaoIBAMA: '', // Sim - Relevante, Sim - Não Relevante, Não
			RestricaoTrabalhoEscravo: '', // Sim, Não
			LCProposto: '', // R$
			SharePretentido: '', // %
			PrazoEmDias: '',
			FonteRecursosCarteira: '',
			ParecerRepresentante: '',
			ParecerCTC: '',
			FixarLimiteCredito: '',
			AcompanharProposta: '',
			AnaliseGrupo: '',
			PotencialPatrimonial: '',
			Ecomm: '', // boolean
		});


		this.proposal.valueChanges.subscribe(data => {
			//console.log("form change", data); Detect any form change
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.initProposal();

		if (window.location.href.indexOf('proposta-lc').toString().length > 0 && !this.proposalIDclosed && !this.proposalOpen) {
			$('html, body').animate({ scrollTop: 0 }, 0);
			if ($(document).find("a[href='#collapseAccountDetail'").attr("aria-expanded") === "true") {
				$(document).find("a[href='#collapseAccountDetail'").trigger("click");
			}
		}
	}

	mask(): any {
		return {
			mask: (value) => {
				value = normalizeDoc(value);
				if (value.length < 12)
					return this.cpfMask;
				else
					return this.cnpjMask;
			}
		};
	}

	initProposal() {
		console.log("initProposal", this.proposalStatus);
		this.getAverage();
		this.getProduct();
		this.getMarket();
		this.getExperience();
		this.getClientTypes();
		this.getArea();
		this.fixedButtons();
	}

	validateCPF(cpf) {
		var Soma;
		var Resto;
		Soma = 0;
		if (cpf == "00000000000") return false;

		for (var i = 1; i <= 9; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
		Resto = (Soma * 10) % 11;

		if ((Resto == 10) || (Resto == 11))  Resto = 0;
		if (Resto != parseInt(cpf.substring(9, 10)) ) return false;

		Soma = 0;
		for (var i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
		Resto = (Soma * 10) % 11;

		if ((Resto == 10) || (Resto == 11))  Resto = 0;
		if (Resto != parseInt(cpf.substring(10, 11) ) ) return false;
		return true;
	}

	sendToPreAnalise() {

		this.removeAutomaticSave();

		$('div, select, input').removeClass("required-alert");

		this.requiredFields = [];
		this.requiredFields = this.proposalRules();

		if (this.requiredFields.length <= 0) {
			this.requestApproval();
		}
	}

	sendPreAnalise() {
		this.removeAutomaticSave();
		this.saveProposal(this.proposal.value, false, 'sendPreAnalise');
	}

	sendToAnalise() {
		this.removeAutomaticSave();
		this.saveProposal(this.proposal.value, false, 'sendToAnalise');
	}

	sairSemSalvar() {
		this.reloadAccountClient();
	}

	reloadAccountClient() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.accountClientID);
			});
	}

	reloadProposal() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.accountClientID+'/proposta-lc');
			});
	}

	sendToEncerrar() {

		this.removeAutomaticSave();

		var message = "Confirma o encerramento da Proposta de LC?";
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmação',
			message: message
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				//We get dialog result
				if (isConfirmed) {
					this.encerrar();
				}
				else {
					//Do nothing here
				}
			});
	}

	encerrar() {
		var data = {
			ID: this.limitFlowProposalService.proposalObj['ID']
		}

		this.limitFlowProposalService.sendToEncerrar(data).subscribe(result => {
			if (result.Success) {
				console.log("Encerrar Proposta: ", result.Result);
				this.flashMessagesService.show("Proposta Encerrada", { cssClass: 'alert-success', timeout: 6000 });
				this.reloadAccountClient();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	proposalRules() {
		if (this.profileUser === 'Representante' ||
			this.profileUser === 'Assistente Técnico Comercial' ||
			this.profileUser === 'Consultor Técnico Comercial' ||
			this.profileUser === 'Gerente Comercial') {

			// Pessoa Física
			if (this.proposalLayout === 1) {

				if (this.proposal.controls['ExperienciaID'].value === '')
					this.requiredFields.push({ id: 'ExperienciaID', msg: 'Experiência obrigatório' });

				if (this.limitFlowProposalService.culturesObj.length === 0)
					this.requiredFields.push({ id: 'Culture', msg: 'Preencha pelo menos uma Cultura' });

				if (!this.regraReferencia())
					this.requiredFields.push({ id: 'Referencia', msg: 'Preencha pelo menos uma Referência Bancária e uma Comercial' });

				if (!this.regraEstadoCivil())
					this.requiredFields.push({
						id: this.proposal.controls['EstadoCivil'].value === '' ? 'EstadoCivil' : "RegraEstadoCivil",
						msg: this.proposal.controls['EstadoCivil'].value === '' ? 'Estado Civil obrigatório' : 'Para o Estado Civil Casado(a), preencha o CPF/Nome do Cônjuge e o Regime de Casamento'
					});

				if (!this.regraArmazem())
					this.requiredFields.push({ id: 'ToneladasArmazem', msg: 'Em caso de Armazém ou Silo Próprio, preencha as Toneladas' });

				if (!this.regraAreaIrrigada())
					this.requiredFields.push({ id: 'AreaIrrigadaID', msg: 'Em caso de Área Irrigada, preencha a Área' });

				if (!this.regraContratoProximaSafra())
					this.requiredFields.push({ id: 'RegraContratoProximaSafra', msg: 'Em caso de Contrato para Próxima Safra, preencha o Trading, Quantidade em Sacas e Preço/Saca' });
			}

			// Pessoa Jurídica - Agropecuária
			if (this.proposalLayout === 2) {

				if (this.limitFlowProposalService.culturesObj.length === 0)
					this.requiredFields.push({ id: 'Culture', msg: 'Preencha pelo menos uma Cultura' });

				if (this.limitFlowProposalService.mainMarketsObj.length === 0)
					this.requiredFields.push({ id: 'principaisMercados', msg: 'Preencha pelo menos um Mercado de Atuação' });

				if (!this.regraReferencia())
					this.requiredFields.push({ id: 'Referencia', msg: 'Preencha pelo menos uma Referência Bancária e uma Comercial' });

				if (this.proposal.controls['NecessidadeAnualFertilizantes'].value <= 0)
					this.requiredFields.push({ id: 'NecessidadeAnualFertilizantes', msg: 'Necessidade Anual de Fertilizante obrigatório' });

				if (this.proposal.controls['PrecoMedioFt'].value <= 0)
					this.requiredFields.push({ id: 'PrecoMedioFt', msg: 'Preço Médio Fertilizante obrigatório' });

				if (this.proposal.controls['NumeroComprasAno'].value <= 0)
					this.requiredFields.push({ id: 'NumeroComprasAno', msg: 'Nº de Compras/Ano obrigatório' });

				if (!this.regraArmazem())
					this.requiredFields.push({ id: 'ToneladasArmazem', msg: 'Em caso de Armazém ou Silo Próprio, preencha as Toneladas' });

				if (!this.regraAreaIrrigada())
					this.requiredFields.push({ id: 'AreaIrrigadaID', msg: 'Em caso de Área Irrigada, preencha a Área' });

				if (!this.regraContratoProximaSafra())
					this.requiredFields.push({ id: 'RegraContratoProximaSafra', msg: 'Em caso de Contrato para Próxima Safra, preencha o Trading, Quantidade em Sacas e Preço/Saca' });
			}

			// Revenda
			if (this.proposalLayout === 3) {

				if (this.limitFlowProposalService.mainMarketsObj.length === 0)
					this.requiredFields.push({ id: 'principaisMercados', msg: 'Preencha pelo menos um Mercado de Atuação' });

				if (!this.regraReferencia())
					this.requiredFields.push({ id: 'Referencia', msg: 'Preencha pelo menos uma Referência Bancária e uma Comercial' });

				if (this.proposal.controls['NecessidadeAnualFertilizantes'].value <= 0)
					this.requiredFields.push({ id: 'NecessidadeAnualFertilizantes', msg: 'Necessidade Anual de Fertilizante obrigatório' });

				if (this.proposal.controls['PrecoMedioFt'].value <= 0)
					this.requiredFields.push({ id: 'PrecoMedioFt', msg: 'Preço Médio Fertilizante obrigatório' });

				if (this.proposal.controls['NumeroComprasAno'].value <= 0)
					this.requiredFields.push({ id: 'NumeroComprasAno', msg: 'Nº de Compras/Ano obrigatório' });

				if (this.proposal.controls['NumeroClienteCooperados'].value <= 0)
					this.requiredFields.push({ id: 'NumeroClienteCooperados', msg: 'Número de Clientes/Cooperados obrigatório' });

				if (this.proposal.controls['PrazoMedioVendas'].value <= 0)
					this.requiredFields.push({ id: 'PrazoMedioVendas', msg: 'Prazo Médio de Vendas a Clientes obrigatório' });
			}

			// Usina
			if (this.proposalLayout === 4) {

				if (!this.regraReferencia())
					this.requiredFields.push({ id: 'Referencia', msg: 'Preencha pelo menos uma Referência Bancária e uma Comercial' });

				if (this.proposal.controls['NecessidadeAnualFertilizantes'].value <= 0)
					this.requiredFields.push({ id: 'NecessidadeAnualFertilizantes', msg: 'Necessidade Anual de Fertilizante obrigatório' });

				if (this.proposal.controls['PrecoMedioFt'].value <= 0)
					this.requiredFields.push({ id: 'PrecoMedioFt', msg: 'Preço Médio Fertilizante obrigatório' });

				if (this.proposal.controls['NumeroComprasAno'].value <= 0)
					this.requiredFields.push({ id: 'NumeroComprasAno', msg: 'Nº de Compras/Ano obrigatório' });

				if (this.proposal.controls['IdadeMediaCanavialID'].value === '')
					this.requiredFields.push({ id: 'IdadeMediaCanavialID', msg: 'Idade Média do Canavial obrigatório' });

				if (this.proposal.controls['TotalProducaoAlcool'].value <= 0)
					this.requiredFields.push({ id: 'TotalProducaoAlcool', msg: 'Total da produção de Álcool (ano) obrigatório' });

				if (this.proposal.controls['TotalProducaoAcucar'].value <= 0)
					this.requiredFields.push({ id: 'TotalProducaoAcucar', msg: 'Total da produção de Açúcar (ano) obrigatório' });

				if (this.proposal.controls['VolumeMoagemPropria'].value <= 0)
					this.requiredFields.push({ id: 'VolumeMoagemPropria', msg: 'Volume de Moagem própria (ano) obrigatório' });

				if (this.proposal.controls['CustoMedioProducao'].value <= 0)
					this.requiredFields.push({ id: 'CustoMedioProducao', msg: 'Custo Médio da Produção (R$/ha) obrigatório' });

				if (this.proposal.controls['CustoCarregamentoTransporte'].value <= 0)
					this.requiredFields.push({ id: 'CustoCarregamentoTransporte', msg: 'Custo de Carregamento e Transporte (/ton) obrigatório' });
			}

			// Pessoa Jurídica
			if (this.proposalLayout === 5) {

				if (this.limitFlowProposalService.mainMarketsObj.length === 0)
					this.requiredFields.push({ id: 'principaisMercados', msg: 'Preencha pelo menos um Mercado de Atuação' });

				if (!this.regraReferencia())
					this.requiredFields.push({ id: 'Referencia', msg: 'Preencha pelo menos uma Referência Bancária e uma Comercial' });

				if (this.proposal.controls['NecessidadeAnualFertilizantes'].value <= 0)
					this.requiredFields.push({ id: 'NecessidadeAnualFertilizantes', msg: 'Necessidade Anual de Fertilizante obrigatório' });

				if (this.proposal.controls['PrecoMedioFt'].value <= 0)
					this.requiredFields.push({ id: 'PrecoMedioFt', msg: 'Preço Médio Fertilizante obrigatório' });

				if (this.proposal.controls['NumeroComprasAno'].value <= 0)
					this.requiredFields.push({ id: 'NumeroComprasAno', msg: 'Nº de Compras/Ano obrigatório' });

				if (this.proposal.controls['NumeroClienteCooperados'].value <= 0)
					this.requiredFields.push({ id: 'NumeroClienteCooperados', msg: 'Número de Clientes/Cooperados obrigatório' });

				if (this.proposal.controls['PrazoMedioVendas'].value <= 0)
					this.requiredFields.push({ id: 'PrazoMedioVendas', msg: 'Prazo Médio de Vendas a Clientes obrigatório' });
			}

			// Pessoa Física com CNPJ
			if (this.proposalLayout === 6) {

				if (this.proposal.controls['ExperienciaID'].value === '')
					this.requiredFields.push({ id: 'ExperienciaID', msg: 'Experiência obrigatório' });

				if (this.proposal.controls['Documento'].value === '') {
					if (this.clienteComCPF) {
						if (this.docList.length < 1) {
							this.requiredFields.push({ id: 'Documento', msg: 'Preencha pelo menos um CNPJ' });
						}
					} else {
						this.requiredFields.push({ id: 'Documento', msg: 'Documento obrigatório' });
					}
				}

				if (!this.clienteComCPF &&
					(!this.validateCPF(normalizeDoc(this.proposal.controls['Documento'].value)) ||
					normalizeDoc(this.proposal.controls['Documento'].value).length < 11)) {
					this.requiredFields.push({ id: 'Documento', msg: 'O CPF digitado é inválido' });
				}

				if (this.limitFlowProposalService.culturesObj.length === 0)
					this.requiredFields.push({ id: 'Culture', msg: 'Preencha pelo menos uma Cultura' });

				if (!this.regraReferencia())
					this.requiredFields.push({ id: 'Referencia', msg: 'Preencha pelo menos uma Referência Bancária e uma Comercial' });

				if (!this.regraEstadoCivil())
					this.requiredFields.push({
						id: this.proposal.controls['EstadoCivil'].value === '' ? 'EstadoCivil' : "RegraEstadoCivil",
						msg: this.proposal.controls['EstadoCivil'].value === '' ? 'Estado Civil obrigatório' : 'Para o Estado Civil Casado(a), preencha o CPF/Nome do Cônjuge e o Regime de Casamento'
					});

				if (!this.regraArmazem())
					this.requiredFields.push({ id: 'ToneladasArmazem', msg: 'Em caso de Armazém ou Silo Próprio, preencha as Toneladas' });

				if (!this.regraAreaIrrigada())
					this.requiredFields.push({ id: 'AreaIrrigadaID', msg: 'Em caso de Área Irrigada, preencha a Área' });

				if (!this.regraContratoProximaSafra())
					this.requiredFields.push({ id: 'RegraContratoProximaSafra', msg: 'Em caso de Contrato para Próxima Safra, preencha o Trading, Quantidade em Sacas e Preço/Saca' });
			}

			// Pessoa Física - Parceria Agrícola
			if (this.proposalLayout === 7) {

				if (this.proposal.controls['ExperienciaID'].value === '')
					this.requiredFields.push({ id: 'ExperienciaID', msg: 'Experiência obrigatório' });

				if (this.limitFlowProposalService.culturesObj.length === 0)
					this.requiredFields.push({ id: 'Culture', msg: 'Preencha pelo menos uma Cultura' });

				if (this.limitFlowProposalService.agriculturalPartnershipObj.length === 0)
					this.requiredFields.push({ id: 'Parceria', msg: 'Preencha pelo menos uma Parceria' });

				if (!this.regraReferencia())
					this.requiredFields.push({ id: 'Referencia', msg: 'Preencha pelo menos uma Referência Bancária e uma Comercial' });

				if (!this.regraArmazem())
					this.requiredFields.push({ id: 'ToneladasArmazem', msg: 'Em caso de Armazém ou Silo Próprio, preencha as Toneladas' });

				if (!this.regraAreaIrrigada())
					this.requiredFields.push({ id: 'AreaIrrigadaID', msg: 'Em caso de Área Irrigada, preencha a Área' });

				if (!this.regraContratoProximaSafra())
					this.requiredFields.push({ id: 'RegraContratoProximaSafra', msg: 'Em caso de Contrato para Próxima Safra, preencha o Trading, Quantidade em Sacas e Preço/Saca' });
			}

			if (!this.regraGarantia())
				this.requiredFields.push({ id: 'ClienteGarantia', msg: 'Em caso de garantias, preencha pelo menos uma' });

			if (this.proposal.controls['LCProposto'].value <= 0)
				this.requiredFields.push({ id: 'LCProposto', msg: 'LC Proposto Obrigatório' });

			if (this.proposal.controls['SharePretentido'].value <= 0)
				this.requiredFields.push({ id: 'SharePretentido', msg: 'Share Pretendido Obrigatório' });

			if (this.proposal.controls['PrazoEmDias'].value <= 0)
				this.requiredFields.push({ id: 'PrazoEmDias', msg: 'Prazo em Dias Obrigatório' });

			if (this.proposal.controls['FonteRecursosCarteira'].value === '')
				this.requiredFields.push({ id: 'FonteRecursosCarteira', msg: 'Fonte de Recursos para pagamento Obrigatório' });

			if (this.profileUser === 'Representante' && (this.proposal.controls['ParecerRepresentante'].value === '' || this.proposal.controls['ParecerRepresentante'].value.length < 100))
				this.requiredFields.push({ id: 'ParecerRepresentante', msg: 'Parecer do Representante Obrigatório (min. 100 caracteres)' });

			if ((this.profileUser === 'Assistente Técnico Comercial' || this.profileUser === 'Consultor Técnico Comercial' || this.profileUser === 'Gerente Comercial') && (this.proposal.controls['ParecerCTC'].value === '' || this.proposal.controls['ParecerCTC'].value.length < 100))
				this.requiredFields.push({ id: 'ParecerCTC', msg: 'Parecer do CTC Obrigatório (min. 100 caracteres)' });

			// Anexos
			var attachEmpty = false;
			this.limitFlowProposalService.attachments.forEach(attach => {
				if (attach.Obrigatorio && !attach.AnexoID) {
					attachEmpty = true;	
				}
			});

			if (attachEmpty) {
				this.requiredFields.push({ id: '', msg: 'Preencha todos os anexos obrigatórios' });
			}

			console.log("Campos Obrigatórios", this.requiredFields);

			for (var key in this.requiredFields) {
				var obj = this.requiredFields[key];
				if (obj.id) {
					$(document).find("#" + obj.id).addClass("required-alert");
					$(document).find("." + obj.id).addClass("required-alert");
				}
			}
		}

		return this.requiredFields;
	}

	sendToCtc() {

		this.removeAutomaticSave();

		$('div, select, input').removeClass("required-alert");
		this.requiredFields = [];
		this.requiredFields = this.proposalRules();

		if (this.requiredFields.length <= 0) {
			this.saveProposal(this.proposal.value, false, 'sendToCtc');
		}

	}

	goToField(id) {
		// $('html, body').animate({
		// 	scrollTop: $('#' + id).parent().parent().offset().top - 74 // fixed buttons div height
		// }, 500);
	}

	sendToComite() {

		this.removeAutomaticSave();

		let disposable = this.dialogService.addDialog(SendToCtcComponent, {
			accountClientID: this.accountClientID,
			proposalID: this.limitFlowProposalService.proposalObj['ID'],
			proposalCTC: this.limitFlowProposalService.proposalObj['CodigoSap'],
			target: 'comite'
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				if (isConfirmed) {
					this.saveProposal(this.proposal.value, false, 'sendToComite');
				}
			});
	}

	requestFixar(final: boolean) {

		var grupo = this.limitFlowProposalService.proposalObj['AnaliseGrupo'];
		var dre = $("#dreObj").val() ? JSON.parse($("#dreObj").val().toString()) : "";
		var groupID = this.limitFlowProposalService.proposalObj['GrupoEconomicoID'];
		var fixacao = [];
		var obj = {};

		// Não participa de um grupo
		if (grupo == 0) {

			obj = {
				Integrante: '',
				Vigencia: this.limitFlowProposalService.proposalObj['DataAprovacaoComite'],
				LimiteSugerido: this.proposal.controls['FixarLimiteCredito'].value,
				VigenciaFimSugerida: this.limitFlowProposalService.proposalObj['DataAprovacaoComite'] ? moment(this.limitFlowProposalService.proposalObj['DataAprovacaoComite']).add(1, 'year') : null,
				VigenciaFim: '',
				ContaClienteID: this.accountClientID,
				PropostaLCId: this.limitFlowProposalService.proposalObj['ID'],
				Rating: dre.Rating
			}

			fixacao.push(obj);

			let disposable = this.dialogService.addDialog(FixedLimitComponent, {
				proposalID: this.limitFlowProposalService.proposalObj['ID'],
				approvalLC: this.proposal.controls['FixarLimiteCredito'].value,
				approvalFinanceGroup: fixacao,
				group: grupo,
				aprovalFinal: final
			},
				{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
				.subscribe((isConfirmed) => {
					if (isConfirmed) {
						if (final) {
							this.flashMessagesService.show("Proposta Aprovada e Finalizada", { cssClass: 'alert-success', timeout: 6000 });
							this.reloadAccountClient();
						} else {
							this.flashMessagesService.show("Limite Parcial Fixado", { cssClass: 'alert-success', timeout: 6000 });
							this.reloadAccountClient();
						}
					}
				});
		} else {

			this.limitFlowProposalService.getIntegrantes(groupID).subscribe(result => {
				if (result.Success) {

					var integrantes = result.Result;
					var groupType; // 1: Compartilhado | 2: Individual | 3: Relações

					for (var key in this.tempGroup) {
						var obj = this.tempGroup[key];
						if (obj.GrupoId === groupID) {
							groupType = obj.ClassificacaoID;
						}
					}

					for (var i = 0; i < integrantes.length; i++) {

						var integrante = {
							Integrante: integrantes[i].Integrante,
							Vigencia: this.limitFlowProposalService.proposalObj['DataAprovacaoComite'],
							LimiteSugerido: integrantes[i].LimiteSugerido, // this.proposal.controls['FixarLimiteCredito'].value,
							VigenciaFimSugerida: integrantes[i].VigenciaSugerida, // this.limitFlowProposalService.proposalObj['DataAprovacaoComite'] ? moment(this.limitFlowProposalService.proposalObj['DataAprovacaoComite']).add(1, 'year') : null,
							VigenciaFim: integrantes[i].VigenciaSugerida,
							ContaClienteID: integrantes[i].ContaClienteID,
							PropostaLCId: this.limitFlowProposalService.proposalObj['ID'],
							Rating: dre.Rating,
							LC: integrantes[i].LimiteSugerido
						}

						if (groupType === 2 || groupType === 3) {
							fixacao.push(integrante);
						} else if (integrante.ContaClienteID === this.accountClientID) {
							fixacao.push(integrante);
						}

					}

					let disposable = this.dialogService.addDialog(FixedLimitComponent, {
						proposalID: this.limitFlowProposalService.proposalObj['ID'],
						approvalLC: this.proposal.controls['FixarLimiteCredito'].value,
						approvalFinanceGroup: fixacao,
						group: grupo,
						aprovalFinal: final
					},
						{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
						.subscribe((isConfirmed) => {
							if (isConfirmed) {
								if (final) {
									this.flashMessagesService.show("Proposta Aprovada e Finalizada", { cssClass: 'alert-success', timeout: 6000 });
									this.reloadAccountClient();
								} else {
									this.flashMessagesService.show("Limite Parcial Fixado", { cssClass: 'alert-success', timeout: 6000 });
									this.reloadAccountClient();
								}
							}
						});

				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			})

		}

	}

	getMask() {
		return this.clienteComCPF ? this.cnpjMask : this.cpfMask;
	}

	requestAprovalPendingWarranty() {

		this.removeAutomaticSave();

		this.saveProposal(this.proposal.value, false, null);

		let disposable = this.dialogService.addDialog(RequestPendingWarrantyComponent, {
			accountClientID: this.accountClientID,
			proposalID: this.limitFlowProposalService.proposalObj['ID'],
			proposalCTC: this.limitFlowProposalService.proposalObj['CodigoSap'],
			userProfile: this.profileUser
		},
		{ backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe((isConfirmed) => {
			this.initProposal();
		});
	}

	requestPendingAproval() {

		this.removeAutomaticSave();

		this.saveProposal(this.proposal.value, false, null);

		let disposable = this.dialogService.addDialog(RequestPendingApprovalComponent, {
			accountClientID: this.accountClientID,
			proposalID: this.limitFlowProposalService.proposalObj['ID'],
			proposalCTC: this.limitFlowProposalService.proposalObj['CodigoSap'],
			userProfile: this.profileUser
		},
		{ backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe((isConfirmed) => {
			this.initProposal();
		});
	}

	regraArmazem() {
		return this.proposal.controls['PossuiArmazem'].value ? this.proposal.controls['ToneladasArmazem'].value > 0 : true;
	}

	regraEstadoCivil() {
		return this.proposal.controls['EstadoCivil'].value === 'Casado(a)' ?

			(this.proposal.controls['CPFConjugue'].value !== '' &&
				this.proposal.controls['NomeConjugue'].value !== '' &&
				this.proposal.controls['RegimeCasamento'].value !== '') : this.proposal.controls['EstadoCivil'].value !== '';
	}

	regraGarantia() {
		return this.proposal.controls['ClienteGarantia'].value ? this.limitFlowProposalService.guaranteesObj.length > 0 : true;
	}

	regraAreaIrrigada() {
		return this.proposal.controls['PossuiAreaIrrigada'].value ? this.proposal.controls['AreaIrrigadaID'].value !== '' : true;
	}

	regraContratoProximaSafra() {
		return this.proposal.controls['PossuiContratoProximaSafra'].value ?
			(this.proposal.controls['Trading'].value !== '' &&
				this.proposal.controls['QtdeSacas'].value > 0 &&
				this.proposal.controls['PrecoSaca'].value > 0) : true
	}

	regraReferencia() {
		var refBancaria = false;
		var refComercial = false;

		for (var key in this.limitFlowProposalService.referencesObj) {
			var obj = this.limitFlowProposalService.referencesObj[key];
			if (obj.TipoReferencia === 'Bancária') {
				refBancaria = true;
			}

			if (obj.TipoReferencia === 'Comercial') {
				refComercial = true;
			}
		}

		return refBancaria && refComercial;
	}

	podeSalvar() {

		var rule;

		switch (this.profileUser) {
			case 'Representante':
				rule = (this.proposalStatus === 'RA' || this.proposalStatus === 'XC' || this.proposalStatus === 'RP') && this.isUserOwner;
				break;

			case 'Assistente Técnico Comercial':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'RP' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Consultor Técnico Comercial':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'RP' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Gerente Comercial':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'RP' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Estagiário de Crédito':
				rule = (this.proposalStatus === 'XC' ||
				this.proposalStatus === 'CA' ||
				this.proposalStatus === 'RP' ||
				this.proposalStatus === 'CP' ||
				this.proposalStatus === 'FP' ||
				this.proposalStatus === 'FF' ||
				this.proposalStatus === 'FC' ||
				this.proposalStatus === 'WA' ||
				this.proposalStatus === 'WG' ||
				this.proposalStatus === 'AP' ||
				this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			case 'Assistente de Crédito':
				rule = (this.proposalStatus === 'XC' ||
				this.proposalStatus === 'CA' ||
				this.proposalStatus === 'RP' ||
				this.proposalStatus === 'CP' ||
				this.proposalStatus === 'FP' ||
				this.proposalStatus === 'FF' ||
				this.proposalStatus === 'FC' ||
				this.proposalStatus === 'WA' ||
				this.proposalStatus === 'WG' ||
				this.proposalStatus === 'AP' ||
				this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = (this.proposalStatus === 'XC' ||
				this.proposalStatus === 'CA' ||
				this.proposalStatus === 'RP' ||
				this.proposalStatus === 'CP' ||
				this.proposalStatus === 'FP' ||
				this.proposalStatus === 'FF' ||
				this.proposalStatus === 'FC' ||
				this.proposalStatus === 'WA' ||
				this.proposalStatus === 'WG' ||
				this.proposalStatus === 'AP' ||
				this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			case 'Coordenador de Crédito': case 'Coordenador de Cobrança':
				rule = (this.proposalStatus === 'XC' ||
				this.proposalStatus === 'CA' ||
				this.proposalStatus === 'RP' ||
				this.proposalStatus === 'CP' ||
				this.proposalStatus === 'FP' ||
				this.proposalStatus === 'FF' ||
				this.proposalStatus === 'FC' ||
				this.proposalStatus === 'WA' ||
				this.proposalStatus === 'WG' ||
				this.proposalStatus === 'AP' ||
				this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			case 'Gerente de Crédito':
				rule = (this.proposalStatus === 'XC' ||
				this.proposalStatus === 'CA' ||
				this.proposalStatus === 'RP' ||
				this.proposalStatus === 'CP' ||
				this.proposalStatus === 'FP' ||
				this.proposalStatus === 'FF' ||
				this.proposalStatus === 'FC' ||
				this.proposalStatus === 'WA' ||
				this.proposalStatus === 'WG' ||
				this.proposalStatus === 'AP' ||
				this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			default:
				rule = false;
				break;
		}

		return rule;

	}

	podeEditar() {

		var rule;

		switch (this.profileUser) {
			case 'Representante':
				rule = false;
				break;

			case 'Assistente Técnico Comercial':
				rule = false;
				break;

			case 'Consultor Técnico Comercial':
				rule = false;
				break;

			case 'Gerente Comercial':
				rule = false;
				break;

			case 'Estagiário de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'FA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FE' ||
					this.proposalStatus === 'FF') && (!this.isUserOwner || !this.podeSalvar());
				break;

			case 'Assistente de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'FA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FE' ||
					this.proposalStatus === 'FF') && (!this.isUserOwner || !this.podeSalvar());
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'FA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FE' ||
					this.proposalStatus === 'FF') && (!this.isUserOwner || !this.podeSalvar());
				break;

			case 'Coordenador de Crédito': case 'Coordenador de Cobrança':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'FA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FE' ||
					this.proposalStatus === 'FF') && (!this.isUserOwner || !this.podeSalvar());
				break;

			case 'Gerente de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'FA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FE' ||
					this.proposalStatus === 'FF') && (!this.isUserOwner || !this.podeSalvar());
				break;

			default:
				rule = false;
				break;
		}

		return rule;

	}

	podeSolicitarPendencia() {

		var rule;

		switch (this.profileUser) {

			case 'Representante':
				rule = false;
				break;

			case 'Assistente Técnico Comercial':
				rule = (this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Consultor Técnico Comercial':
				rule = (this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Gerente Comercial':
				rule = (this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Estagiário de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'RA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			case 'Assistente de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'RA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'RA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			case 'Coordenador de Crédito': case 'Coordenador de Cobrança':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'RA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			case 'Gerente de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'RA' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'AF') && this.isUserOwner;
				break;

			default:
				rule = false;
				break;
		}

		return rule;

	}

	podeEnviarCTC() {
		var rule;

		switch (this.profileUser) {
			case 'Representante':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'RP') && this.isUserOwner;
				break;
			default:
				rule = false;
				break;
		}

		return rule;
	}

	podeEnviarParaPreAnalise() {
		var rule;

		switch (this.profileUser) {
			case 'Representante':
				rule = false;
				break;

			case 'Assistente Técnico Comercial':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'RP' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Consultor Técnico Comercial':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'RP' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Gerente Comercial':
			rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'RP' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Estagiário de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Assistente de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Coordenador de Crédito': case 'Coordenador de Cobrança':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			case 'Gerente de Crédito':
				rule = (this.proposalStatus === 'XC' ||
					this.proposalStatus === 'CA' ||
					this.proposalStatus === 'FF' ||
					this.proposalStatus === 'RP' ||
					this.proposalStatus === 'CP') && this.isUserOwner;
				break;

			default:
				rule = false;
				break;
		}

		return rule;
	}

	podeEnviarParaAnalise() {
		var rule;

		switch (this.profileUser) {

			case 'Estagiário de Crédito':
				rule = false;
				break;

			case 'Assistente de Crédito':
				rule = this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FC';
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = this.proposalStatus === 'FP' ||
					this.proposalStatus === 'FC';
				break;

			default:
				rule = false;
				break;
		}

		return rule;
	}

	podeEnviarAoComite() {
		var rule;

		switch (this.profileUser) {
			case 'Estagiário de Crédito':
				rule = this.proposalStatus === 'FF';
				break;

			case 'Assistente de Crédito':
				rule = this.proposalStatus === 'FF';
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = this.proposalStatus === 'FF';
				break;

			case 'Coordenador de Crédito': case 'Coordenador de Cobrança':
				rule = this.proposalStatus === 'FF';
				break;

			case 'Gerente de Crédito':
				rule = this.proposalStatus === 'FF';
				break;

			default:
				rule = false;
				break;
		}

		return rule;
	}

	podeFixarLcSolicitarPendencia() {
		var rule;

		switch (this.profileUser) {
			case 'Assistente de Crédito':
				rule = this.proposalStatus === 'WA';
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = this.proposalStatus === 'WA';
				break;
			default:
				rule = false;
				break;
		}

		return rule;
	}

	podeSolicitarGarantia() {
		var rule;

		switch (this.profileUser) {
			case 'Assistente de Crédito':
				rule = this.proposalStatus === 'WA';
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = this.proposalStatus === 'WA';
				break;

			default:
				rule = false;
				break;
		}

		return rule;
	}

	podeFixarLcParcial() {
		var rule;

		switch (this.profileUser) {
			case 'Assistente de Crédito':
				rule = this.proposalStatus === 'FC' && this.proposal.controls['FixarLimiteCredito'].value > 0;
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = this.proposalStatus === 'FC' && this.proposal.controls['FixarLimiteCredito'].value > 0;
				break;

			default:
				rule = false;
				break;
		}

		return rule;
	}

	podeFixarLc() {
		var rule;

		switch (this.profileUser) {
			case 'Assistente de Crédito':
				rule = this.proposalStatus === 'WA' || this.proposalStatus === 'AG' || this.proposalStatus === 'AP';
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = this.proposalStatus === 'WA' || this.proposalStatus === 'AG' || this.proposalStatus === 'AP';
				break;

			default:
				rule = false;
				break;
		}

		return rule;
	}

	podeEncerrar() {
		var rule;

		switch (this.profileUser) {
			case 'Representante':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'RP') && this.isUserOwner;
				break;

			case 'Assistente Técnico Comercial':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP' || this.proposalStatus === 'RP') && this.isUserOwner;
				break;

			case 'Consultor Técnico Comercial':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP' || this.proposalStatus === 'RP') && this.isUserOwner;
				break;

			case 'Gerente Comercial':
				rule = (this.proposalStatus === 'XC' || this.proposalStatus === 'CA' || this.proposalStatus === 'CP' || this.proposalStatus === 'RP') && this.isUserOwner;
				break;

			case 'Assistente de Crédito':
				rule = (this.isUserOwner && this.proposalStatus !== 'FA' && this.proposalStatus !== 'FE') ||
					(this.proposalStatus === 'FC' || this.proposalStatus === 'WA' || this.proposalStatus === 'WG' || this.proposalStatus === 'AG' || this.proposalStatus === 'AP');
				break;

			case 'Analista de Crédito Jr':
			case 'Analista de Crédito Pl':
			case 'Analista de Crédito Sr':
			case 'Supervisor de Crédito':
				rule = (this.isUserOwner && this.proposalStatus !== 'FA' && this.proposalStatus !== 'FE') ||
					(this.proposalStatus === 'FC' || this.proposalStatus === 'WA' || this.proposalStatus === 'WG' || this.proposalStatus === 'AG' || this.proposalStatus === 'AP');
				break;

			case 'Coordenador de Crédito': case 'Coordenador de Cobrança':
				rule = (this.isUserOwner && this.proposalStatus !== 'FA' && this.proposalStatus !== 'FE') ||
					(this.proposalStatus === 'FC' || this.proposalStatus === 'WA' || this.proposalStatus === 'WG' || this.proposalStatus === 'AG' || this.proposalStatus === 'AP');
				break;

			case 'Gerente de Crédito':
				rule = (this.isUserOwner && this.proposalStatus !== 'FA' && this.proposalStatus !== 'FE') ||
					(this.proposalStatus === 'FC' || this.proposalStatus === 'WA' || this.proposalStatus === 'WG' || this.proposalStatus === 'AG' || this.proposalStatus === 'AP');
				break;

			default:
				rule = false;
				break;
		}

		if ((this.proposalStatus === 'AP' || this.proposalStatus === 'WG') && this.isUserOwner === false)
			rule = false;

		return rule;
	}

	isApprover() {
		return this.proposalStatus === 'FC' && this.isUserOwner;
	}

	podeSairSemSalvar() {
		return true;
	}

	setKeepProposal(key) {
		this.keepProposal = key;
		this.proposal.patchValue({
			AcompanharProposta: key
		});
	}

	editProposal() {
		this.limitFlowProposalService.editProposal(this.limitFlowProposalService.proposalObj['ID']).subscribe(result => {
			if (result.Success) {
				this.initProposal();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	fixedButtons() {
		$(window).bind('scroll', function () {
			if ($('.proposal-breadcrumb').offset()) {
				if ($(window).scrollTop() > $('.proposal-breadcrumb').offset().top) {
					$('.proposal-buttons').addClass('fixed');
				} else {
					$('.proposal-buttons').removeClass('fixed');
				}
			}
		});
	}

	ruleRepresentante() {
		if (this.limitFlowProposalService.blockProposalField(this.proposalStatus, this.isUserOwner) === 'disabled' ||
		this.profileUser !== 'Representante') {
			return 'disabled';
		} else {
			return null;
		}
	}

	ruleCTC() {
		if (this.limitFlowProposalService.blockProposalField(this.proposalStatus, this.isUserOwner) === 'disabled' ||
		(this.profileUser !== 'Assistente Técnico Comercial' &&
		this.profileUser !== 'Consultor Técnico Comercial' &&
		this.profileUser !== 'Gerente Comercial')) {
			return 'disabled';
		} else {
			return null;
		}
	}

	ngOnDestroy() {
		this.limitFlowProposalService.proposalObj = [];
		this.limitFlowProposalService.ruralsObj = [];
		this.limitFlowProposalService.priceByRegionObj = [];
		this.limitFlowProposalService.urbansObj = [];
		this.limitFlowProposalService.machinesObj = [];
		this.limitFlowProposalService.culturesObj = [];
		this.limitFlowProposalService.guaranteesObj = [];
		this.limitFlowProposalService.livestocksObj = [];
		this.limitFlowProposalService.referencesObj = [];
		this.limitFlowProposalService.otherRevenueObj = [];
		this.limitFlowProposalService.typeOfObj = [];
		this.limitFlowProposalService.segmentsObj = [];
		this.limitFlowProposalService.agriculturalPartnershipObj = [];
		this.limitFlowProposalService.mainMarketsObj = [];
		this.limitFlowProposalService.groupMembers = [];
		this.limitFlowProposalService.attachments = [];

		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}
	}

	setAutomaticSave(key) {
		if (key) {
			if (this.timerSubscription) {
				this.timerSubscription.unsubscribe();
			}
			this.timerSubscription = this.timer.subscribe(() => {
				this.saveProposal(this.proposal.value, true, 'automatic');
			});
		} else {
			this.lastAutomaticSave = "";
			if (this.timerSubscription) {
				this.timerSubscription.unsubscribe();
			}
		}
	}

	setProposalTab(tab) {

		this.proposalLcTab = false;
		this.patrimonyTab = false;
		this.revenueTab = false;
		this.guaranteeTab = false;
		this.ratingTab = false;
		this.summaryTab = false;
		this.attachTab = false;
		this.demosTab = false;
		this.groupTab = false;
		this.blogTab = false;
		this.logTab = false;

		switch (tab) {
			case 'proposal':
				this.proposalLcTab = true;
				break;
			case 'patrimony':
				this.patrimonyTab = true;
				break;
			case 'revenue':
				this.revenueTab = true;
				break;
			case 'guarantee':
				this.guaranteeTab = true;
				break;
			case 'rating':
				this.ratingTab = true;
				break;
			case 'summary':
				this.summaryTab = true;
				break;
			case 'attach':
				this.attachTab = true;
				break;
			case 'demos':
				this.demosTab = true;
				break;
			case 'group':
				this.groupTab = true;
				break;
			case 'blog':
				this.blogTab = true;
				break;
			case 'log':
				this.logTab = true;
				break;
			default:

				break;
		}
	}

	setProposalType(clienteTypeID) {
		this.proposalLayout = 0;
		for (var i = 0; i < this.clientTypes.length; i++) {
			if (this.clientTypes[i].ID === clienteTypeID) {
				this.proposalLayout = this.clientTypes[i].LayoutProposta;
			}
		}

		$("#ProposalLayout").val(this.proposalLayout);

		this.limitFlowProposalService.proposalReload.next(true); // Aba anexos recebe essa mudança e recarrega
		console.log("Layout Selecionado:", this.proposalLayout);
	}

	setDocMask() {
		if (this.clienteComCPF) {
			($('.doc-field') as any).mask('AA.AAA.AAA/AAAA-00', { reverse: true });
		} else {
			($('.doc-field') as any).mask('000.000.000-00', { reverse: true });
		}
	}

	setCpfMask() {
		($('.cpfConjugue') as any).mask('000.000.000-00', { reverse: true });
	}

	populateCpf(cpf) {
		cpf = normalizeDoc(cpf);
		if (cpf.length === 11) {
			this.getMarriageInfo(cpf);
		} else {
			//this.proposal.get('NomeConjugue').disable();
			this.proposal.patchValue({
				NomeConjugue: ""
			});
		}
	}

	getMarriageInfo(cpf) {
		this.limitFlowProposalService.getAccountClient(this.token, cpf).subscribe(result => {
			if (result.Success) {
				this.proposal.patchValue({
					NomeConjugue: result.Result[0] ? result.Result[0].Nome : ""
				});
				if (result.Result[0] && result.Result[0].Nome !== "") {
					//this.proposal.get('NomeConjugue').disable();
				} else {
					//this.proposal.get('NomeConjugue').enable();
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	loadProposal() {
		this.limitFlowProposalService.getLcProposal(this.proposalIDclosed).subscribe(result => {
			if (result.Success) {
				console.log("Carregou a proposta para visualização: ", result.Result);
				this.populateProposal(result.Result);
				this.limitFlowProposalService.proposalObj = result.Result ? result.Result : [];
				this.isUserOwner = result.Result ? result.Result.ResponsavelID === localStorage.getItem('yara.userID') ? true : false : false;

				this.isEdicao = true;
				this.guid = localStorage.getItem('yara.userID');
				this.proposalStatus = result.Result.PropostaLCStatusID;

				// this.getPatrimonyByDocument(this.currentClientDocument);
				// for (var key in result.Result.Garantias) {
				// 	var obj = result.Result.Garantias[key];
				// 	this.getPatrimonyByDocument(obj.Documento);
				// }
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	getAccountClienteType() {
		console.log("getAccountClienteType", this.proposalStatus);
		this.limitFlowProposalService.getAccountClienteType(this.token, this.accountClientID).subscribe(result => {
			console.log("getAccountClienteType", result.Success);
			if (result.Success) {

				if (result.Result) { //&& (result.Result.TipoClienteID && result.Result.TipoClienteID !== '00000000-0000-0000-0000-000000000000')) {
					this.proposal.controls['TipoClienteID'].setValue(result.Result.TipoClienteID);
					this.setProposalType(result.Result.TipoClienteID ? result.Result.TipoClienteID : "");

					if (result.Result.Documento && result.Result.Documento.length === 11) {
						this.clienteComCPF = true;
					} else {
						this.clienteComCPF = false;
					}

					if (!this.proposalIDclosed) {
						this.getProposalByAccountClientId(false);
					} else {
						this.loadProposal();
					}

				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	insertCnpj() {
		var cnpj = $(".doc-field").val().toString();
		if (normalizeDoc(cnpj).length === 14) {
			this.docList.push(cnpj);
			$(".doc-field").val("").focus();
		}
	}

	removeCnpj(index) {
		delete this.docList[index];
		this.docList = this.docList.filter(item => item);
	}

	addMarket(market) {
		console.log(market);
		var exists = false;
		for (var key in this.limitFlowProposalService.mainMarketsObj) {
			var obj = this.limitFlowProposalService.mainMarketsObj[key];
			if (obj.CulturaID === market.ID) {
				exists = true;
			}
		}

		if (!exists) {
			this.limitFlowProposalService.mainMarketsObj.push({
				Cultura: market,
				CulturaID: market.ID
			});
			this.TipoMercadoAtuacao = "";
			this.flashMessagesService.show("Mercado de atuação adicionado", { cssClass: 'alert-success', timeout: 6000 });
		} else {
			this.flashMessagesService.show("Mercado de atuação já adicionado", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	removeMarket(market) {
		this.limitFlowProposalService.mainMarketsObj = this.limitFlowProposalService.mainMarketsObj.filter(item => item !== market);
		this.flashMessagesService.show("Mercado de atuação removido", { cssClass: 'alert-success', timeout: 6000 });
	}

	searchAccountClient(value) {
		value = normalizeDoc(value);
		this.limitFlowProposalService.getAccountClient(this.token, value).subscribe(result => {
			if (result.Success) {
				if (result.Result.length === 1) {
					var accountClient = result.Result && result.Result[0] ? result.Result[0].Nome : null;
					if (accountClient) {
						console.log(this.accountClient.controls);
						this.accountClient.controls["Nome"].setValue(accountClient);
					}
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	removeAccountClient(account) {
		this.limitFlowProposalService.agriculturalPartnershipObj = this.limitFlowProposalService.agriculturalPartnershipObj.filter(item => item !== account);
		this.flashMessagesService.show("Parceria removida", { cssClass: 'alert-success', timeout: 6000 });
	}

	addAccountClient(account) {
		var exists = false;
		for (var key in this.limitFlowProposalService.agriculturalPartnershipObj) {
			var obj = this.limitFlowProposalService.agriculturalPartnershipObj[key];
			if (obj.Documento === account.Documento) {
				exists = true;
			}
		}

		if (!exists) {
			this.limitFlowProposalService.agriculturalPartnershipObj.push(account);
		} else {
			this.flashMessagesService.show("Essa Parceria já foi adicionada", { cssClass: 'alert-danger', timeout: 6000 });
		}
		this.accountClient.reset();
	}

	getPatrimonyByDocument(documento) {
		let doc = normalizeDoc(documento);

		if (doc.length == 10 || doc.length === 11 || doc.length === 14) {

			this.isLoadingPatrimony = true;

			this.limitFlowProposalService.getPatrimonusByDocument(doc).subscribe(result => {
				if (result.Success) {

					console.log("[getPatrimonyByDocument] : Buscou os patrimonios/preços por região do cliente e dos fiadores", result.Result);

					// Preenche os patrimonios do fiador
					var bensRurais = result.Result.BemRural;
					var bensUrbanos = result.Result.BemUrbano;
					var bensMaquinas = result.Result.MaquinasEquipamentos;
					var precosPorRegiao = result.Result.PrecosPorRegiao;

					if (bensRurais.length > 0) {
						for (var i = 0; i < bensRurais.length; i++) {
							var obj = bensRurais[i];
							if (obj) {
								obj.Documento = doc;
								
								const existsIndex = this.limitFlowProposalService.ruralsObj.findIndex(res => res.ID == obj.ID);
								if (existsIndex == -1) {
									if (Number(doc) === Number(this.currentClientDocument)) {
										obj.GarantiaID = null;
										obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
									}
									this.limitFlowProposalService.ruralsObj.push(obj);
								}
							}
						}
					}

					if (bensUrbanos.length > 0) {
						for (var i = 0; i < bensUrbanos.length; i++) {
							var exists = false;
							var obj = bensUrbanos[i];
							if (obj) {
								obj.Documento = doc;
								for (var z = 0; z < this.limitFlowProposalService.urbansObj.length; z++) {
									var objUrbans = this.limitFlowProposalService.urbansObj[z];
									if (objUrbans) {
										if (obj.IR === objUrbans.IR &&
											obj.Descricao === objUrbans.Descricao &&
											obj.AreaTotal === objUrbans.AreaTotal &&
											obj.ValorComBenfeitorias === objUrbans.ValorComBenfeitorias &&
											obj.Onus === objUrbans.Onus &&
											obj.ValorAvaliado === objUrbans.ValorAvaliado &&
											obj.Documento === objUrbans.Documento) {
											exists = true;
										}
									}
								}
								if (!exists) {
									if (Number(doc)  === Number(this.currentClientDocument)) {
										obj.GarantiaID = null;
										obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
									}
									this.limitFlowProposalService.urbansObj.push(obj);
								}
							}
						}
					}

					if (bensMaquinas.length > 0) {
						for (var i = 0; i < bensMaquinas.length; i++) {
							var exists = false;
							var obj = bensMaquinas[i];
							if (obj) {
								obj.Documento = doc;
								for (var z = 0; z < this.limitFlowProposalService.machinesObj.length; z++) {
									var objMachines = this.limitFlowProposalService.machinesObj[z];
									if (objMachines) {
										if (obj.Descricao === objMachines.Descricao &&
											obj.Ano === objMachines.Ano &&
											obj.Valor === objMachines.Valor &&
											obj.Documento === objMachines.Documento) {
											exists = true;
										}
									}
								}
								if (!exists) {
									if (Number(doc) === Number(this.currentClientDocument)) {
										obj.GarantiaID = null;
										obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
									}
									this.limitFlowProposalService.machinesObj.push(obj);
								}
							}
						}
					}

					if (precosPorRegiao.length > 0) {
						for (var i = 0; i < precosPorRegiao.length; i++) {
							var exists = false;
							var obj = precosPorRegiao[i];
							if (obj) {
								obj.Documento = doc;
								for (var z = 0; z < this.limitFlowProposalService.priceByRegionObj.length; z++) {
									var objPrices = this.limitFlowProposalService.priceByRegionObj[z];
									if (objPrices) {
										if (obj.Cidade.Nome === objPrices.Cidade.Nome &&
											obj.ValorHaCultivavel === objPrices.ValorHaCultivavel &&
											obj.ValorHaNaoCultivavel === objPrices.ValorHaNaoCultivavel &&
											obj.ModuloRural === objPrices.ModuloRural &&
											obj.ValorHaCultivavelParametro === objPrices.ValorHaCultivavelParametro &&
											obj.ValorHaNaoCultivavelParametro === objPrices.ValorHaNaoCultivavelParametro &&
											obj.ModuloRuralParametro === objPrices.ModuloRuralParametro &&
											obj.Documento === objPrices.Documento) {
											exists = true;
										}
									}
								}
								if (!exists) {
									if (Number(doc) === Number(this.currentClientDocument)) {
										obj.GarantiaID = null;
										obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
									}
									this.limitFlowProposalService.priceByRegionObj.push(obj);
								}
							}
						}
					}

					// Atualiza o patrimonio da garantia
					for (var i = 0; i < this.limitFlowProposalService.guaranteesObj.length; i++) {
						if (this.limitFlowProposalService.guaranteesObj[i].Documento === documento) {
							this.limitFlowProposalService.guaranteesObj[i].PotencialPatrimonial = result.Result.PotencialPatrimonial;
						}
					}

					this.isLoadingPatrimony = false;
				} else {
					this.isLoadingPatrimony = false;

					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				this.isLoadingPatrimony = false;
				console.log(error);
			});
		}
	}

	getIntegrantes(value) {
		if (value) {
			this.limitFlowProposalService.getIntegrantes(value).subscribe(result => {
				if (result.Success) {
					this.limitFlowProposalService.groupMembers = result.Result;

					for (var i = 0; i < this.limitFlowProposalService.groupMembers.length; i++) {
						console.log('vigenciaSugerida',this.limitFlowProposalService.groupMembers[i].VigenciaSugerida);

						if (this.limitFlowProposalService.groupMembers[i].VigenciaSugerida != null) {
							//this.vigenciaSugerida[this.limitFlowProposalService.groupMembers[i].Documento] = moment(this.limitFlowProposalService.groupMembers[i].VigenciaSugerida).format("YYYY-MM-DD");
							const tempDate = moment(this.limitFlowProposalService.groupMembers[i].VigenciaSugerida).toDate();
							this.limitFlowProposalService.groupMembers[i].VigenciaSugerida = {date:{year: tempDate.getFullYear(), month: tempDate.getMonth()+1, day: tempDate.getDate()}};
						}
					}

					this.getPatrimonyByDocument(this.currentClientDocument);
					for (var key in this.limitFlowProposalService.guaranteesObj) {
						var obj = this.limitFlowProposalService.guaranteesObj[key];
						this.getPatrimonyByDocument(obj.Documento);
					}

					for (var i = 0; i < this.limitFlowProposalService.groupMembers.length; i++) {
						this.getPatrimonyByDoc(this.limitFlowProposalService.groupMembers[i].Documento);
						if (this.accountClientID !== this.limitFlowProposalService.groupMembers[i].ContaClienteID) {
							this.getRevenuesByDoc(this.limitFlowProposalService.groupMembers[i].Documento);
						}
					}

				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			})
		}
	}

	getRevenuesByDoc(documento) {
		let doc = normalizeDoc(documento);

		if (doc.length == 10 || doc.length === 11 || doc.length === 14) {
			this.limitFlowProposalService.getRevenuesByDocument(doc).subscribe(result => {
				if (result.Success) {
					console.log("Me ajuda", documento);
					console.log("Socorro", result.Result);
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
	}

	getPatrimonyByDoc(documento) {
		let doc = normalizeDoc(documento);

		if (doc.length == 10 || doc.length === 11 || doc.length === 14) {
			
			this.isLoadingPatrimony = true;

			this.limitFlowProposalService.getPatrimonusByDocument(doc).subscribe(result => {
				if (result.Success) {

					console.log("[getPatrimonyByDoc] : Buscou os patrimonios/preços por região do cliente e dos fiadores", result.Result);
	
					// Preenche os patrimonios do fiador
					var bensRurais = result.Result.BemRural;
					var bensUrbanos = result.Result.BemUrbano;
					var bensMaquinas = result.Result.MaquinasEquipamentos;
					var precosPorRegiao = result.Result.PrecosPorRegiao;

					for (var keyRurais in bensRurais) {
						var obj = bensRurais[keyRurais];
						if (obj) {
							obj.Documento = doc;
						
							const existsIndex = this.limitFlowProposalService.ruralsObj.findIndex(res => res.ID == obj.ID);
							if (existsIndex == -1) {
								this.limitFlowProposalService.ruralsObj.push(obj);
							}
						}
					}

					for (var keyUrbanos in bensUrbanos) {
						var exists = false;
						var obj = bensUrbanos[keyUrbanos];
						if (obj) {
							obj.Documento = doc;
							for (var keyUrbanosObj in this.limitFlowProposalService.urbansObj) {
								var objUrbans = this.limitFlowProposalService.urbansObj[keyUrbanosObj];
								if (objUrbans) {
									if (obj.IR === objUrbans.IR &&
										obj.Descricao === objUrbans.Descricao &&
										obj.AreaTotal === objUrbans.AreaTotal &&
										obj.ValorComBenfeitorias === objUrbans.ValorComBenfeitorias &&
										obj.Onus === objUrbans.Onus &&
										obj.ValorAvaliado === objUrbans.ValorAvaliado &&
										obj.Documento === objUrbans.Documento) {
										exists = true;
									}
								}
							}
							if (!exists) {
								this.limitFlowProposalService.urbansObj.push(obj);
							}
						}
					}
	
					for (var keyMaquinas in bensMaquinas) {
						var exists = false;
						var obj = bensMaquinas[keyMaquinas];
						if (obj) {
							obj.Documento = doc;
							for (var keyMaquinasObj in this.limitFlowProposalService.machinesObj) {
								var objMachines = this.limitFlowProposalService.machinesObj[keyMaquinasObj];
								if (objMachines) {
									if (obj.Descricao === objMachines.Descricao &&
										obj.Ano === objMachines.Ano &&
										obj.Valor === objMachines.Valor &&
										obj.Documento === objMachines.Documento) {
										exists = true;
									}
								}
							}
							if (!exists) {
								this.limitFlowProposalService.machinesObj.push(obj);
							}
						}
					}
	
					for (var keyPrecos in precosPorRegiao) {
						var exists = false;
						var obj = precosPorRegiao[keyPrecos];
						if (obj) {
							obj.Documento = doc;
							for (var keyPrecosObj in this.limitFlowProposalService.priceByRegionObj) {
								var objPrices = this.limitFlowProposalService.priceByRegionObj[keyPrecosObj];
								if (objPrices) {
									if (obj.Cidade.Nome === objPrices.Cidade.Nome &&
										obj.ValorHaCultivavel === objPrices.ValorHaCultivavel &&
										obj.ValorHaNaoCultivavel === objPrices.ValorHaNaoCultivavel &&
										obj.ModuloRural === objPrices.ModuloRural &&
										obj.ValorHaCultivavelParametro === objPrices.ValorHaCultivavelParametro &&
										obj.ValorHaNaoCultivavelParametro === objPrices.ValorHaNaoCultivavelParametro &&
										obj.ModuloRuralParametro === objPrices.ModuloRuralParametro &&
										obj.Documento === objPrices.Documento) {
										exists = true;
									}
								}
							}
							if (!exists) {
								this.limitFlowProposalService.priceByRegionObj.push(obj);
							}
						}
					}
	
					var tempMembers = [];
	
					// Atualiza o patrimonio do integrante
					for (var i = 0; i < this.limitFlowProposalService.groupMembers.length; i++) {
						if (this.limitFlowProposalService.groupMembers[i].Documento === documento) {
							this.limitFlowProposalService.groupMembers[i].PotencialPatrimonial = result.Result.PotencialPatrimonial;
							this.limitFlowProposalService.groupMembers[i].PotencialReceita = result.Result.PotencialReceita;
						}
	
						var data = {
							PropostaLCID: this.limitFlowProposalService.proposalObj['ID'],
							PotencialPatrimonial: Number(this.limitFlowProposalService.groupMembers[i].PotencialPatrimonial),
							PotencialReceita: Number(this.limitFlowProposalService.groupMembers[i].PotencialReceita),
							Documento: this.limitFlowProposalService.groupMembers[i].Documento
						}
	
						tempMembers.push(data);
					}
	
					$("#integrantesDreDoc").val(JSON.stringify(tempMembers));
	
					this.isLoadingPatrimony = false;
				} else {
					this.isLoadingPatrimony = false;

					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				this.isLoadingPatrimony = false;
				console.log(error);
			});
		}
	}

	getProposalByAccountClientId(isAutomatic) {
		this.limitFlowProposalService.getProposalByAccountClientId(this.token, this.accountClientID).subscribe(result => {
			if (result.Success) {

				console.log("getProposalByAccountClientId > Result", result);

				this.limitFlowProposalService.proposalObj = result.Result ? result.Result : [];
				this.isUserOwner = result.Result ? result.Result.ResponsavelID === localStorage.getItem('yara.userID') ? true : false : false;

				if (!result.Result) {
					this.proposal.patchValue({
						ContaClienteID: this.accountClientID
					});

					this.saveProposal(this.proposal.value, false, null);
				} else {
					this.isEdicao = true;

					this.populateProposal(result.Result);
					this.guid = localStorage.getItem('yara.userID');
					this.proposalStatus = result.Result.PropostaLCStatusID;

					console.log("getProposalByAccountClientId > Editou ID", this.proposalStatus);

					if (this.isApprover()) {
						this.proposalLcTab = true;
						this.patrimonyTab = false;
						this.revenueTab = false;
						this.guaranteeTab = false;
						this.ratingTab = false;
						this.attachTab = false;
						this.demosTab = false;
						this.groupTab = false;
						this.blogTab = false;
						this.logTab = false;
						this.summaryTab = true;
						setTimeout(function () {
							$(".nav-tabs .nav-link, #formProposal, #formGuarantee, #formBlog, #formDemos, #formPatrimony, #formRevenue, #formGroup, #formRating, #formAttach, #formLog").removeClass("active");
							$(".tab-summary, #formSummary").addClass("active");
						}, 500);
					}

					// Limpa as listas
					this.limitFlowProposalService.ruralsObj = [];
					this.limitFlowProposalService.urbansObj = [];
					this.limitFlowProposalService.machinesObj = [];
					this.limitFlowProposalService.priceByRegionObj = [];

					if (result.Result.AnaliseGrupo) {
						this.getIntegrantes(result.Result.GrupoEconomicoID);
					} else {

						this.getPatrimonyByDocument(this.currentClientDocument);
						for (var key in result.Result.Garantias) {
							var obj = result.Result.Garantias[key];
							this.getPatrimonyByDocument(obj.Documento);
						}

					}

					if (this.podeSalvar()) {
						this.getAutoSaveTimeParameter();
					}

					//this.flashMessagesService.show("Proposta carregada com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				}

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
			
			if (isAutomatic) {
				setTimeout(function () { $(document).find(".ng-progress, .ng-progress.active").show(); }, 1000);
			}

		}, error => {
			if (isAutomatic) {
				setTimeout(function () { $(document).find(".ng-progress, .ng-progress.active").show(); }, 1000);
			}
			console.log(error);
			return false;
		});
	}

	getArea() {
		this.limitFlowProposalService.getArea(this.token).subscribe(result => {
			if (result.Success) {
				this.areas = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getProductivity() {
		this.limitFlowProposalService.getProductivity(this.token).subscribe(result => {
			if (result.Success) {
				this.productivitys = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getCultures() {
		this.limitFlowProposalService.getCulture(this.token).subscribe(result => {
			if (result.Success) {
				this.cultures = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getState() {
		this.commonService.getState(this.token).subscribe(result => {
			if (result.Success) {
				this.states = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getCity(stateID) {
		this.commonService.getCity(this.token, stateID).subscribe(result => {
			if (result.Success) {
				this.citys = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	maxLengthCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength)
		}
	}

	percentualCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength);
		} else {
			if (e.target.value > 100) {
				e.target.value = 100;
			} else if (e.target.value < 0) {
				e.target.value = 0;
			}
		}
	}

	// Produtos
	saveProposalProduct(product, value) {

		console.log(product);

		var data = {
			ProdutoServicoID: product.ID,
			ProdutoServico: product,
			Quantidade: value
		}

		this.limitFlowProposalService.segmentsObj.push(data);
		this.flashMessagesService.show("Necessidade de produto adicionada", { cssClass: 'alert-success', timeout: 6000 });
		this.TipoProdutoID = "";
		this.Quantidade = "";
	}

	deleteProposalProduct(product) {
		this.limitFlowProposalService.segmentsObj = this.limitFlowProposalService.segmentsObj.filter(item => item !== product);
		this.flashMessagesService.show("Necessidade de produto removida", { cssClass: 'alert-success', timeout: 6000 });
	}

	saveProposal(proposal: any, isAutomatic, action) {

		if (this.groupTab) {
			$(".solicitacao-tab").trigger("click");
			this.reloadGrupTab = true;
		}

		var data = proposal;

		if (data) {
			data.PrecosPorRegiao = this.limitFlowProposalService.priceByRegionObj;
			data.BensRurais = this.limitFlowProposalService.ruralsObj;
			data.BensUrbanos = this.limitFlowProposalService.urbansObj;
			data.MaquinasEquipamentos = this.limitFlowProposalService.machinesObj;
			data.Culturas = this.limitFlowProposalService.culturesObj;
			data.Garantias = this.limitFlowProposalService.guaranteesObj;
			data.CriacoesAnimais = this.limitFlowProposalService.livestocksObj;
			data.Referencias = this.limitFlowProposalService.referencesObj;
			data.OutrasReceitas = this.limitFlowProposalService.otherRevenueObj;
			data.TiposEndividamento = this.limitFlowProposalService.typeOfObj;
			data.NecessidadeProduto = this.limitFlowProposalService.segmentsObj;
			data.ParceriasAgricolas = this.limitFlowProposalService.agriculturalPartnershipObj;
			data.PrincipaisMercados = this.limitFlowProposalService.mainMarketsObj;

			data.PotencialPatrimonial = this.limitFlowProposalService.proposalObj['PotencialPatrimonial'];
			data.ValorTotalBensRurais = $("#valorTotalBensRurais").val();
			data.ValorTotalBensUrbanos = $("#valorTotalBensUrbanos").val();
			data.ValorTotalMaquinasEquipamentos = $("#valorTotalMaquinasEquipamentos").val();
			data.ReceitaTotal = $("#receitaTotal").val();
			data.ComentarioPatrimonio = $("#comentarioPatrimonio").val();
			data.GrupoEconomicoID = this.limitFlowProposalService.proposalObj['GrupoEconomicoID']
			data.AnaliseGrupo = this.limitFlowProposalService.proposalObj['AnaliseGrupo'];
			data.ParecerAnalista = $("#ParecerAnalista").val();

			var potencialCreditoPF = $("#PotencialCreditoPF").val();
			if (potencialCreditoPF) {
				data.PotencialCredito = potencialCreditoPF;
			}

			var dre = $("#dreObj").val() ? $("#dreObj").val().toString() : "";
			if (dre !== "") {
				var obj = JSON.parse(dre);
				data.DemonstrativoFinanceiroID = obj.DemonstrativoFinanceiroID;
				data.BalancoAuditado = obj.BalancoAuditado;
				data.EmpresaAuditora = obj.EmpresaAuditora;
				data.Ressalvas = obj.Ressalvas;
				data.Rating = obj.Rating;
				data.PotencialCredito = obj.PotencialCredito;
			} else {
				data.DemonstrativoFinanceiroID = "";
				data.BalancoAuditado = "";
				data.EmpresaAuditora = "";
				data.Ressalvas = "";
				data.Rating = "";
				data.PotencialCredito = "";
			}
		}

		if (this.clienteComCPF) {
			var cnpjs = "";
			for (var i = 0; i < this.docList.length; i++) {
				cnpjs += this.docList[i] + ",";
			}
			data.Documento = cnpjs;
		}

		console.log("When I SAVE IT", data);

		var objGroup = $("#integrantesDreDoc").val() ? JSON.parse($("#integrantesDreDoc").val().toString()) : [];

		if (this.limitFlowProposalService.proposalObj['AnaliseGrupo'] && objGroup.length > 0) {
			this.saveDreGroupIntegral(objGroup, data, action);
		} else {
			this.saveProposalService(data, isAutomatic, action);
		}
	}

	removeAutomaticSave() {
		this.automaticSave = false;
		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}
	}

	requestPending() {

		this.removeAutomaticSave();

		this.saveProposal(this.proposal.value, false, null);

		let disposable = this.dialogService.addDialog(RequestPendingComponent, {
			accountClientID: this.accountClientID,
			proposalID: this.limitFlowProposalService.proposalObj['ID'],
			proposalCTC: this.limitFlowProposalService.proposalObj['CodigoSap'],
			proposalRepresentative: this.limitFlowProposalService.proposalObj['RepresentanteID'],
			userProfile: this.profileUser
		},
		{ backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe((isConfirmed) => {
			if (isConfirmed) {
				this.initProposal();
			}
		});
	}

	sendToComiteAction() {

		var data = {
			PropostaLCID: this.limitFlowProposalService.proposalObj['ID'],
			CodigoSap: this.limitFlowProposalService.proposalObj['CodigoSap']
		}

		this.limitFlowProposalService.sendToComite(data).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta enviada ao Comitê de aprovação", { cssClass: 'alert-success', timeout: 6000 });
				this.reloadProposal();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	sendToCtcAction() {

		let disposable = this.dialogService.addDialog(SendToCtcComponent, {
			accountClientID: this.accountClientID,
			proposalID: this.limitFlowProposalService.proposalObj['ID'],
			proposalCTC: this.limitFlowProposalService.proposalObj['CodigoSap'],
			target: 'ctc'
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				if (isConfirmed)
					this.initProposal();
			});
	}

	sendPreAnaliseAction() {

		var data = {
			ID: this.limitFlowProposalService.proposalObj['ID'],
			CodigoSap: this.limitFlowProposalService.proposalObj['CodigoSap']
		}

		this.limitFlowProposalService.sendPreAnalise(data).subscribe(result => {
			if (result.Success) {
				this.initProposal();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	sendToPreAnaliseAction() {

		let disposable = this.dialogService.addDialog(SendToCtcComponent, {
			accountClientID: this.accountClientID,
			proposalID: this.limitFlowProposalService.proposalObj['ID'],
            proposalCTC: this.limitFlowProposalService.proposalObj['CodigoSap'],
			target: 'preAnalise'
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				if (isConfirmed)
					this.initProposal();
			});
	}

	sendToAnaliseAction() {

		if (this.proposalStatus === 'FC' && this.summaryTab) {
			this.proposalLcTab = true;
			this.summaryTab = false;

			setTimeout(function () {
				$(".solicitacao-tab, #formProposal").addClass("active");
				$(".tab-summary, #formSummary").removeClass("active");
			}, 500);
		}

		var data = {
			ID: this.limitFlowProposalService.proposalObj['ID']
		}

		this.limitFlowProposalService.sendToAnalise(data).subscribe(result => {
			if (result.Success) {
				console.log("Send To Pre Analise: ", result.Result);
				this.initProposal();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	saveProposalService(data, isAutomatic, action) {
		if (action === 'sendToComite') {
			data.CodigoSap = this.limitFlowProposalService.proposalObj['CodigoSap'];
		}

		if (!this.isLoadingPatrimony) {
			this.isSaving = true;

			this.limitFlowProposalService.saveProposal(this.token, data, isAutomatic).subscribe(result => {
				if (result.Success) {
					this.isSaving = false;

					if (isAutomatic) {
						this.flashMessagesService.show("Salvo automaticamente", { cssClass: 'alert-success', timeout: 6000 });
						this.lastAutomaticSave = moment().format("HH:mm");
					} else {
						this.flashMessagesService.show("Proposta salva com sucesso", { cssClass: 'alert-success', timeout: 6000 });
					}

					if (this.reloadGrupTab) {
						this.reloadGrupTab = false;
						$(".tab-group").trigger("click");
					}
	
					this.isEdicao = true;
	
					if (this.automaticSave) {
						if (this.timerSubscription) {
							this.timerSubscription.unsubscribe();
						}
						this.timerSubscription = this.timer.subscribe(() => {
							this.saveProposal(this.proposal.value, true, null);
						});
					}
	
					if (action) {
						if (action === 'sendToComite') {
							this.sendToComiteAction();
						} else if (action === 'sendToCtc') {
							this.sendToCtcAction();
						} else if (action === 'sendPreAnalise') {
							this.sendPreAnaliseAction();
						} else if (action === 'sendToPreAnalise') {
							this.sendToPreAnaliseAction();
						} else if (action === 'sendToAnalise') {
							this.sendToAnaliseAction();
						} else if (action === 'requestApproval') {
							this.requestApprovalAction();
						}
					} else {					
						this.getProposalByAccountClientId(isAutomatic);
					}
				} else {
					this.isSaving = false;

					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });

					this.reloadAccountClient();
				}
				
			}, error => {
				this.isSaving = false;
				console.log(error);
			});
		}
	}

	saveDreGroupIntegral(obj, data, action) {
		this.limitFlowProposalService.saveDreGroupIntegral(obj).subscribe(result => {
			if (result.Success) {
				console.log("Salva a lista de documentos dre por integrante");
				this.saveProposalService(data, false, action);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				this.saveProposalService(data, false, action);
			}
		}, error => {
			this.saveProposalService(data, false, action);
			console.log(error);
		});
	}

	getAutoSaveTimeParameter() {
		this.limitFlowProposalService.getAutoSaveTimeParameter(this.token).subscribe(result => {
			if (result.Success) {
				var time = result.Result[0].Valor ? result.Result[0].Valor : 20;
				this.autoSaveTime = time * 1000;
				this.timer = Observable.timer(this.autoSaveTime);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	populateProposal(proposal) {
		
		Object.keys(proposal).forEach(field => {
			if (this.proposal.controls[field]) {
				if (typeof (proposal[field]) !== 'object') {
					this.proposal.controls[field].setValue(proposal[field]);
				}
			}
		});

		this.docList = [];

		if (!this.clienteComCPF) {
			($('.doc-field') as any).mask('000.000.000-00', { reverse: true });
		} else {
			var docs = proposal.Documento ? proposal.Documento.split(",") : "";

			if (docs) {
				for (var key in docs) {
					var obj = docs[key];
					if (obj)
						this.docList.push(obj);
				}

				this.proposal.patchValue({
					Documento: ''
				});
			}
		}

		// Para visualização, utilizar os patrimonios da proposta (Nãpop consulta pelo documento)
		if (this.proposalIDclosed) {
			this.limitFlowProposalService.priceByRegionObj = proposal.PrecosPorRegiao ? proposal.PrecosPorRegiao : [];
			this.limitFlowProposalService.ruralsObj = proposal.BensRurais ? proposal.BensRurais : [];
			this.limitFlowProposalService.urbansObj = proposal.BensUrbanos ? proposal.BensUrbanos : [];
			this.limitFlowProposalService.machinesObj = proposal.MaquinasEquipamentos ? proposal.MaquinasEquipamentos : [];
		}

		this.limitFlowProposalService.culturesObj = proposal.Culturas ? proposal.Culturas : [];
		this.limitFlowProposalService.guaranteesObj = proposal.Garantias ? proposal.Garantias : [];
		this.limitFlowProposalService.livestocksObj = proposal.CriacoesAnimais ? proposal.CriacoesAnimais : [];
		this.limitFlowProposalService.referencesObj = proposal.Referencias ? proposal.Referencias : [];
		this.limitFlowProposalService.otherRevenueObj = proposal.OutrasReceitas ? proposal.OutrasReceitas : [];
		this.limitFlowProposalService.typeOfObj = proposal.TiposEndividamento ? proposal.TiposEndividamento : [];
		this.limitFlowProposalService.segmentsObj = proposal.NecessidadeProduto ? proposal.NecessidadeProduto : [];
		this.limitFlowProposalService.agriculturalPartnershipObj = proposal.ParceriasAgricolas ? proposal.ParceriasAgricolas : [];
		this.limitFlowProposalService.mainMarketsObj = proposal.PrincipaisMercados ? proposal.PrincipaisMercados : [];

		this.keepProposal = proposal.AcompanharProposta;

		this.dreObj = {
			DemonstrativoFinanceiroID: proposal.DemonstrativoFinanceiroID,
			BalancoAuditado: proposal.BalancoAuditado,
			EmpresaAuditora: proposal.EmpresaAuditora,
			Ressalvas: proposal.Ressalvas,
			Rating: proposal.Rating,
			PotencialCredito: proposal.PotencialCredito
		};

		this.limitFlowProposalService.proposalObj['PotencialPatrimonial'] = proposal.PotencialPatrimonial;

		$("#dreObj").val(JSON.stringify(this.dreObj));
		$("#valorTotalBensRurais").val(proposal.ValorTotalBensRurais);
		$("#valorTotalBensUrbanos").val(proposal.ValorTotalBensUrbanos);
		$("#valorTotalMaquinasEquipamentos").val(proposal.ValorTotalMaquinasEquipamentos);
		$("#receitaTotal").val(proposal.ReceitaTotal);
		$("#comentarioPatrimonio").val(proposal.ComentarioPatrimonio);
		$("#ParecerAnalista").val(proposal.ParecerAnalista);

		this.limitFlowProposalService.proposalObj['ID'] = proposal.ID;

		console.log("Proposta preenchida", proposal);
	}

	getExperience() {
		this.limitFlowProposalService.getExperience(this.token).subscribe(result => {
			if (result.Success) {
				this.experiences = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	getAverage() {
		this.limitFlowProposalService.getAverage(this.token).subscribe(result => {
			if (result.Success) {
				this.averages = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	getProduct() {
		if (this.products.length === 0) {
			this.limitFlowProposalService.getProduct(this.token).subscribe(result => {
				if (result.Success) {
					this.products = result.Result;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);

			});
		}
	}

	getMarket() {
		this.limitFlowProposalService.getCulture(this.token).subscribe(result => {
			if (result.Success) {
				this.markets = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	getClientTypes() {
		this.limitFlowProposalService.getClientType(this.token).subscribe(result => {
			if (result.Success) {
				this.clientTypes = result.Result.filter(item => item.Ativo);
				console.log("getClientTypes", this.proposalStatus);
				this.getAccountClienteType();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	requestApproval() {
		this.removeAutomaticSave();
		this.saveProposal(this.proposal.value, false, 'requestApproval');
	}

	requestApprovalAction() {
		this.limitFlowProposalService.checkSerasa(this.limitFlowProposalService.proposalObj['ID']).subscribe(result => {
			if (result.Success) {
				if (result.Result){
					this.showSerasaModal("Restrição no Serasa detectada.");
				} else {
					if (this.limitFlowProposalService.proposalObj['CodigoSap']) {
						this.saveProposal(this.proposal.value, false, 'sendPreAnalise');
					} else {
						this.saveProposal(this.proposal.value, false, 'sendToPreAnalise');
					}
				}
			} else {
				console.log(result.Errors);
				this.showSerasaModal(result.Errors);
			}
		}, error => {
			console.log(error);
		});
	}

	showSerasaModal(mensagens) {
		var obj = {
			ID: this.limitFlowProposalService.proposalObj['ID'],
			CodigoSap: this.limitFlowProposalService.proposalObj['CodigoSap']
		}

		this.dialogService.addDialog(CcSerasaModalLCComponent, {
			mensagemPendencia: mensagens,
			objSerasa: obj,
			proposalID: this.limitFlowProposalService.proposalObj['ID'],
			clientID: this.accountClientID
		},
		{
			backdropColor: 'rgba(0, 0, 0, 0.5)'
		}).subscribe((result) => {
			//We get dialog result
			switch(result)
			{
				default: case 0: break; //Do nothing here
				case 1:
					if (this.limitFlowProposalService.proposalObj['CodigoSap']) {
						this.saveProposal(this.proposal.value, false, 'sendPreAnalise');
					} else {
						this.saveProposal(this.proposal.value, false, 'sendToPreAnalise');
					}
					break;
				case 2: this.encerrar(); break;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/limit-flow-proposal.component.ts